import {
  Button,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import chevronDown from "../../assets/images/chevronDown.svg";
import chevronUp from "../../assets/images/chevronUp.svg";
import "./moreactionmenu.scss";
import infoIcon from "../../assets/images/info.svg";
import editIcon from "../../assets/images/edit.svg";
import deleteIcon from "../../assets/images/delete.svg";
import moreVertIcon from "../../assets/images/moreVert.svg";
import RemoveSenior from "../modals/RemoveSenior";
import RemoveSuccess from "../modals/RemoveSuccess";
import { searchParams } from "../../utlis/helpers";
import { useNavigate } from "react-router-dom";
import { useNavigateKeepParams } from "../../utlis/useNavigateKeepParams";
import { TEST_HISTORY } from "../../routes/routerPath";
import testHistoryIcon from "../../assets/images/testHistory.svg";
import { pageLocale } from "../../utlis/locale";
import { isWebView } from "../../utlis/webViewBridge";

const MoreActionMenu = ({ userInfo }) => {
  const [open, setOpen] = useState(false);
  const [removeSeniorModal, setRemoveSeniorModal] = useState(false);
  const [removePopUp, setRemovePopup] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  const {
    more_action,
    test_history,
    test_person_info,
    edit_info,
    remove_person,
  } = pageLocale("testModule");
  const navigate = useNavigate();
  const navigateKeepParams = useNavigateKeepParams();

  const viewTestPersonHandler = () => {
    setOpen(false);
    if (isWebView()) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "OPEN_VIEW_TEST_PERSON",
          seniorUuid: userInfo?.id,
        }),
      );
    } else {
      navigateKeepParams(`/view-test-person?seniorUuid=${userInfo?.id}`);
    }
  };

  const editTestPersonHandler = () => {
    sessionStorage.clear("userList");
    setOpen(false);
    if (isWebView()) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "OPEN_EDIT_TEST_PERSON",
          seniorUuid: userInfo?.id,
        }),
      );
    } else {
      navigateKeepParams(`/edit-test-person?seniorUuid=${userInfo?.id}`);
    }
  };

  const testHistoryHandler = () => {
    navigate(TEST_HISTORY + `${searchParams}`);
  };

  return (
    <>
      <div className="more-action-wrapper">
        <Button
          ref={anchorRef}
          className="more-action-button"
          id="composition-button"
          aria-label={more_action}
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          endIcon={
            !open ? (
              <img src={chevronDown} className="end-icon" />
            ) : (
              <img src={chevronUp} className="end-icon" />
            )
          }
        >
          <img
            src={moreVertIcon}
            alt=""
            className="mobile-view-more-action-btn"
            aria-hidden={true}
          />

          <Typography className="more-action-text">{more_action}</Typography>
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
          className="more-action-dropdown-block"
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper className="more-action-dropdown-wrapper">
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    className="more-action-menulist-block"
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                  >
                    <MenuItem
                      className="menu-item"
                      onClick={viewTestPersonHandler}
                    >
                      <img src={infoIcon} alt="info" className="icon" />
                      {test_person_info}
                    </MenuItem>
                    <MenuItem
                      className="menu-item"
                      onClick={() => testHistoryHandler(true)}
                    >
                      <img src={testHistoryIcon} alt="info" className="icon" />
                      {test_history}
                    </MenuItem>

                    <MenuItem
                      className="menu-item"
                      onClick={editTestPersonHandler}
                    >
                      <img src={editIcon} alt="edit" className="icon" />
                      {edit_info}
                    </MenuItem>
                    <MenuItem
                      onClick={() => setRemoveSeniorModal(true)}
                      className="menu-item"
                    >
                      <img src={deleteIcon} alt="delete" className="icon" />
                      {remove_person}
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
      {removeSeniorModal && (
        <RemoveSenior
          removeSeniorModal={removeSeniorModal}
          setRemoveSeniorModal={setRemoveSeniorModal}
          setRemovePopup={setRemovePopup}
          userInfo={userInfo}
        />
      )}
      <RemoveSuccess
        removePopUp={removePopUp}
        setRemovePopup={setRemovePopup}
        userInfo={userInfo}
      />
    </>
  );
};

export default MoreActionMenu;
